import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink, PrimaryLink } from '../Common/Links';
import * as styles from './HeadingCtas.module.css';

const HeadingCtas = ({ ctas = [], className, bkColor }) => {
  if (ctas.length === 1 && ctas[0].linkStyle === 'Arrow Link') {
    return <HeadingCta cta={ctas[0]} bkColor={bkColor} />;
  }
  return (
    <div className={[styles.ctas, className].join(' ')}>
      {ctas.map((cta) => {
        return <HeadingCta cta={cta} bkColor={bkColor} />;
      })}
    </div>
  );
};

const HeadingCta = ({ cta, bkColor }) => {
  if (!cta) {
    return null;
  }

  const scroll = (url) => {
    if (typeof window !== 'undefined') {
      let el = document.getElementById(url.substring(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', offset: 84 });
      }
    }
  };

  const onPrimaryClick = (e) => {
    e.preventDefault();
    let url = cta.url;
    if (url[0] === '#') {
      scroll(url);
    } else {
      if (cta.opensNewPage) window.open(cta.url, '_blank');
      else window.location.href = url;
    }
  };

  return (
    <>
      {cta.linkStyle === 'Arrow Link' && (
        <ArrowLink
          label={cta.linkText}
          isArrowDown={cta.isJumpLink}
          onClick={onPrimaryClick}
          url={cta.isJumpLink ? '' : cta.url}
        />
      )}
      {!cta.linkStyle ||
        (cta.linkStyle === 'Primary Button' && (
          <PrimaryLink
            label={cta.linkText}
            onClick={onPrimaryClick}
            backgroundColor={bkColor}
            isButton={true}
            url={cta.url}
          />
        ))}
      {cta.linkStyle === 'Secondary Button' && (
        <PrimaryLink
          label={cta.linkText}
          onClick={onPrimaryClick}
          isButton={true}
          url={cta.url}
          backgroundColor={'white'}
        />
      )}
    </>
  );
};

HeadingCtas.propTypes = {
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      linkText: PropTypes.string,
      linkStyle: PropTypes.string,
      url: PropTypes.string,
      opensNewPage: PropTypes.bool,
      opensVideoModal: PropTypes.bool,
      isJumpLink: PropTypes.bool,
    })
  ).isRequired,
  bkColor: PropTypes.string,
};

export default HeadingCtas;
